import SocialMedia from "components/About/SocialMedia";
import HeroBusinessAdvisory from "components/BusinessAdvisory/HeroBusinessAdvisory";
import ListBusinessAdvisory from "components/BusinessAdvisory/ListBusinessAdvisory";
import MissionBusinessAdvisory from "components/BusinessAdvisory/MissionBusinessAdvisory";
import QuoteBusinessAdvisory from "components/BusinessAdvisory/QuoteBusinessAdvisory";
import BookSection from "components/Events/BookSection";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BusinessAdvisory = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroBusinessAdvisory /> */}
      <MissionBusinessAdvisory />
      <QuoteBusinessAdvisory />
      <div id="businessinvestmentadvisory">
        {" "}
        <ListBusinessAdvisory />
      </div>
      {/* <PriceSection /> */}
      <BookSection />
    </div>
  );
};

export default BusinessAdvisory;
